export default [
  {
    path: 'faq',
    name: 'Faq',
    component: () => import(/* webpackChunkName: "syshelp" */ '@/views/system/faqs/Faq.vue')
  }
];
